import { IBillingStatusState, EBillingStatus } from '../../../types/reducers/billingStatus';

export const DEFAULT_RESULT: IBillingStatusState = {
  status: EBillingStatus.Ok,
  problemReasons: {
    deposit: null,
    identification: null,
  },
};
